module.exports = new __parcel__URL__("shop_holder_exclusive_button_inactive.43817a38.png").toString();